import { LOADING_POST_DETAIL } from '../actions/types';

export { postList } from './post-list';
export { postDetail } from './post-detail';

export const loadingPostDetail = function(state = false, action) {
    switch (action.type) {
    case LOADING_POST_DETAIL:
        return action.payload;
    default:
        return state;
    }
};
